// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textfield/index.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Controlled } from './Controlled.story';
import { DisabledReadOnly } from './DisabledReadOnly.story';
import { Invalid } from './Invalid.story';
import { Primary } from './Primary.story';
import { Size } from './Size.story';
import { Type } from './Type.story';
import { Uncontrolled } from './Uncontrolled.story';
import { Width } from './Width.story';
const basic = {
  rendered: <Primary />,
  source: `<TextField
  label="Business name"
  placeholder="Acme Inc…"
  onChange={(e) => {
    console.log(e.target.value);
  }}
/>`
};
const type = {
  rendered: <Type />,
  source: `<Box
  css={{
    layout: 'column',
    gap: 'medium',
  }}
>
  <TextField label="Text" type="text" />
  <TextField label="Password" type="password" />
  <TextField label="Search" type="search" />
  <TextField label="Number" type="number" />
</Box>`
};
const size = {
  rendered: <Size />,
  source: `<Box
  css={{
    layout: 'column',
    gap: 'medium',
  }}
>
  <TextField label="Small" size="small" />
  <TextField label="Medium" size="medium" />
  <TextField label="Large" size="large" />
</Box>`
};
const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<TextField
  onChange={(e) => {
    console.log(e);
  }}
  label="First name"
/>`
};
const width = {
  rendered: <Width />,
  source: `<TextField label="Age" css={{width: css.value('42px')}} />`
};
const invalid = {
  rendered: <Invalid />,
  source: `<TextField label="Current year" defaultValue="1892" invalid />`
};
const disabledReadOnly = {
  rendered: <DisabledReadOnly />,
  source: `<Box
  css={{
    layout: 'column',
    gap: 'medium',
  }}
>
  <TextField label="Disabled" defaultValue="Field is disabled" disabled />
  <TextField label="Readonly" defaultValue="Field is readonly" readOnly />
</Box>`
};
const controlled = {
  rendered: <Controlled />,
  source: `const [textValue, setTextValue] = React.useState<string>();

return (
  <TextField
    value={textValue}
    onChange={(e) => {
      setTextValue(e.target.value);
      console.log(e);
    }}
    label="First name"
  />
);`
};
export const TextFieldExamples = {
  basic,
  controlled,
  uncontrolled,
  disabledReadOnly,
  invalid,
  width,
  size,
  type
};